import { CommonModule } from '@angular/common';
import {
  Component,
  Inject,
  ViewChild,
  ViewContainerRef,
  OnInit,
  ComponentRef,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
interface DialogData<T = any> {
  title: string;
  component: any;
  componentData?: T;
  cancelText: any;
  confirmText: any;
}
@Component({
  selector: 'app-generic-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.scss'],
})
export class GenericDialogComponent<T extends object> implements OnInit {
  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
  private componentRef!: ComponentRef<any>;

  constructor(
    public dialogRef: MatDialogRef<GenericDialogComponent<T>>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData<T>,
  ) {}

  ngOnInit() {
    if (this.container) {
      if (this.data.component) {
        this.loadDynamicComponent();
      }
    }
  }
  ngAfterContentInit() {
    if (this.container) {
      if (this.data.component) {
        this.loadDynamicComponent();
      }
    }
  }

  loadDynamicComponent() {
    if (this.container) {
      this.container.clear();
      const component = this.container.createComponent(this.data.component);

      if (this.data.componentData) {
        Object.assign(component.instance as T, this.data.componentData);
      }
      this.componentRef = component;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
